import styled from "@emotion/styled";
import { Menu } from "../../menu";

export const TabMenuFlyoutStyled = styled(Menu)`
    .sds-tab-menu-items-container {
        display: flex;
        justify-content: start;
        margin-inline-start: 24px;
        margin-inline-end: 24px;

        &.is-selected {
            margin-inline-start: 4px;
        }
    }
`;
